import moment from "moment";
import Vue from "../main";

export const serializeDate = (date: Date): string => moment(date)
  .format(`YYYY-MM-DDTHH:mm:ss${ Vue.$store.getters.timezone.offset }`);
